export default __webpack_public_path__ + "static/media/Next.32b84012.svg";